import { render } from "./FileUploadComponent.vue?vue&type=template&id=4b1f455c"
import script from "./FileUploadComponent.vue?vue&type=script&lang=js"
export * from "./FileUploadComponent.vue?vue&type=script&lang=js"

import "./FileUploadComponent.vue?vue&type=style&index=0&id=4b1f455c&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__